<template>
  <v-card
    flat
    class="ma-3 pa-6"
  >
    <v-row align="center" class="pl-0 mb-6 pt-3 pr-3">
      <v-card-title>
        Techniques
      </v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        outlined
        dense
        v-model="filter.query"
        placeholder="Search..."
        append-icon="fas fa-search"
        clearable
        clear-icon="fas fa-times"
        single-line
        hide-details
        @keyup="searchKeyUp()"
        @click:clear="searchKeyUp()"
      ></v-text-field>
      <v-btn
        class="ml-4"
        depressed
        color="secondary"
        @click="newClick"
        :disabled="!user.can('technique.create')"
      >
    <v-icon
      small
      left
    >fas fa-folder-plus</v-icon>
    New
    </v-btn>
    </v-row>

    <v-data-table
      :class="{ 'clickable': user.can('technique.update') }"
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalCount"
      :footer-props="{ 'items-per-page-options': [5, 10, 50] }"
      :loading="isSearching"
      @click:row="rowClick"
    >

    </v-data-table>


    <v-dialog
      v-model="dialog"
      max-width="700"
      persistent
    >
      <v-card>
        <v-toolbar color="primary" dark flat short class="px-2">
          <v-toolbar-title>Technique</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" icon><v-icon>fas fa-times</v-icon></v-btn>
        </v-toolbar>

        <v-card-text class="mt-12">
          <v-form @submit.prevent>
            <v-text-field
              outlined
              class="mb-2"
              v-model="model.description"
              :error-messages="errors.description"
              label="Description"
            ></v-text-field>

            <v-text-field
              outlined
              class="mb-2"
              v-model="model.slug"
              :error-messages="errors.slug"
              label="Slug"
            ></v-text-field>

            <number-field
              outlined
              class="mb-2"
              v-model="model.minimum_quantity"
              :error-messages="errors.minimum_quantity"
              label="Minimum Quantity"
              decimals="0"
              decimal-separator="."
              suffix="pcs"
            ></number-field>

          </v-form>
        </v-card-text>

        <v-card-actions class="px-6 pb-8">
          <v-btn
            v-if="model.id"
            color="error"
            class=""
            large
            outlined
            depressed
            @click="$refs.deleteItemConfirmDialog.show()"
          >Delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="px-5"
            large
            outlined
            depressed
            @click="dialog = false"
          >Cancel</v-btn>
          <v-btn
            color="primary"
            class="px-5"
            large
            depressed
            @click="saveClick()"
          >Save</v-btn>
        </v-card-actions>

        <ConfirmDialog
          ref="deleteItemConfirmDialog"
          @confirm="deleteItem()"
          title="Confirm"
          message="Technique will be deleted. Are you sure?"
          labelConfirm="OK"
          labelCancel="Cancel"
        ></ConfirmDialog>

      </v-card>

    </v-dialog>

  </v-card>
  
</template>

<script>
import { inject, ref } from 'vue'
import NumberField from '@/components/NumberField.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
    NumberField,
  },
  setup() {
    const api = inject('api')
    const loader = inject('loader')
    const { user } = api

    const itemCollection = api.collection('techniques', {
      params: {
      },
      filter: {
        query: 'query:description,slug',
      },
      store: true,
    })

    const { items, filter, totalCount, options, isSearching } = itemCollection

    const headers = [
      { text: 'Description', value: 'description', },
      { text: 'Slug', value: 'slug' },
      { text: 'Minimum Quantity', value: 'minimum_quantity' },
    ]

    const dialog = ref(false)

    const itemModel = api.model('techniques/:id', {
      params: {
      },
    })
    const { attributes: model, errors, isBusy } = itemModel

    loader.bindRef(isBusy)

    function newClick() {
      itemModel.clear().setAttributes({ status: 9 })
      dialog.value = true
    }

    function rowClick(item) {
      if (user.can('technique.update')) {
        itemModel.find(item.id).then(() => {
          dialog.value = true
        })
      }
    }

    function saveClick() {
      itemModel.save().then(() => {
        itemCollection.search()
        dialog.value = false
      })
    }

    function deleteItem() {
      itemModel.delete().then(() => {
        itemCollection.search()
        dialog.value = false
      })
    }

    const searchKeyUp = itemCollection.debounceSearch(300)

    return {
      user,
      headers,
      items,
      filter,
      searchKeyUp,
      totalCount,
      options,
      isSearching,
      newClick,
      rowClick,
      saveClick,
      deleteItem,
      dialog,
      model,
      errors,
    }

  },
}
</script>


<style scoped>

:deep(.v-data-table.clickable table tbody tr:not(.v-data-table__empty-wrapper):hover) {
  cursor: pointer;
}

</style>
